







































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import QuestionArray from "../Question/QuestionArray";
import Question, {ERRORS_TOTAL_LIMIT} from "../Question/Question";
import QuestionCmpt from "../Question/QuestionCmpt.vue";
import Timer from "@/components/Timer/Timer.vue";
import Loader from "@/components/Loader.vue";
import Result from "../Results/Result";
import ThemesCounter, {ERRORS_LIMIT} from "../Theme/ThemesCounter";

@Component({
    components: {
        QuestionCmpt,
        Loader,
        Timer,
    }
})
export default class Testing extends Vue {

    @Action("getAdditionalQuestions") public getAdditionalQuestions: any;
    @Action("writeResult") public writeResult: any;
    @Action("writeResults") public writeResults: any;
    @Getter("inProgress") public inProcess!: boolean;
    @Getter("isExam") public isExam!: boolean;
    @Getter("questions") public questions!: QuestionArray;
    @Getter("examThemes") public examThemes!: number[];
    @Prop({type: String}) public data_title!: string;

    public currentIndex: number = 0;
    public countAnswers: number = 0;
    public countErrors: number = 0;
    public hint: boolean = false;
    public bonusQuestions: boolean = false;
    public time: string = "";
    public themes: ThemesCounter = new ThemesCounter();

    // public timerIcon: string[] = ['fa', 'stopwatch'];

    @Watch("time")
    public async isFinish(newVal: number, oldVal: number) {
        if (this.questionsCount > 0 && this.countAnswers === this.questionsCount) {
            // console.log("want finish");

            if (this.isExam && !this.bonusQuestions) {
                // console.log(this.themes.failures);
                if (this.themes.status && this.countErrors < ERRORS_TOTAL_LIMIT && this.countErrors > 0 && this.themes.failures) {
                    const failures: number [] = this.themes.failures;
                    // console.log("preview", failures);
                    this.bonusQuestions = true;

                    await this.getAdditionalQuestions(failures);
                    // console.log("next");
                    this.next();
                } else {
                    this.finish();
                }

            } else if (this.isExam && this.bonusQuestions) {
                this.finish();
            } else if (!this.isExam) {
                this.finish();
            }

        }
    }

    get questionsCount(): number {
        return this.questions.length;
    }

    get result(): string {
        return this.status ? "Сдано!" : "Не сдано!";
    }

    get resultClass(): string {
        return !this.status ? "red" : "green";
    }

    get reason(): string | null {
        if (!this.themes.status && this.countAnswers === this.questions.length && this.countErrors <= ERRORS_TOTAL_LIMIT) {
            return `Вы допустили более ${ERRORS_LIMIT} ошибки в одной теме`;
        } else if (this.countAnswers === this.questions.length && this.countErrors > ERRORS_TOTAL_LIMIT) {
            return `Вы допустили более ${ERRORS_TOTAL_LIMIT}-х ошибок`;
        } else if (this.countAnswers !== this.questions.length) {
            return "Вы не уложились во время";
        } else {
            return null;
        }
    }

    get showInfo(): boolean {
        return !this.isExam || (this.isExam && !this.inProcess);
    }

    // get errorsClass(): string {
    //     return this.countErrors > 0 ? "bg-danger text-white" : "bg-success text-white";
    // }

    /**
     * Is exam is pass?
     */
    get status(): boolean {
        return this.themes.status && this.countAnswers === this.questionsCount && this.countErrors < ERRORS_TOTAL_LIMIT;
    }

    getNavLiClass(item: Question, index: number): string {
        let out: string = "";

        if (index !== this.currentIndex) {
            if (this.showInfo) {
                if (item.status === false) {
                    out = " bg-danger text-white ";
                } else if (item.status === true) {
                    out = " bg-success text-white ";
                }
            }
        } else {
            out += " active ";
        }

        const startClip: number = 4;
        const isLeft: boolean = this.currentIndex < startClip;
        const isRight: boolean = this.currentIndex > this.questionsCount - startClip;
        const breakCount: number = 5;
        const round: number = 1;

        if (isLeft && index > breakCount && index !== this.questionsCount - 1) {
            out += " not ";
        } else if (isLeft && index === breakCount) {
            out += " right ";
        } else if (isRight && index !== 0 && index < this.questionsCount - breakCount) {
            out += " not ";
        } else if (isRight && index === this.questionsCount - breakCount) {
            out += " left ";
        } else if (!isRight && !isLeft) {
            if (index !== 0 && index !== this.questionsCount - 1
                && index !== this.currentIndex && Math.abs(this.currentIndex - index) > round) {

                out += " not ";
            } else if (index === this.currentIndex - round) {
                out += " left ";
            } else if (index === this.currentIndex + round) {
                out += " right ";
            }
        }

        return out;
    }

    public timeOut() {
        this.finish();
    }

    get question(): Question | null {
        if (this.questions.length > 0) {
            return this.questions.getByIndex(this.currentIndex);
        } else {
            return null;
        }
    }

    selectAnswer() {
        this.countAnswers++;

        if (this.question && !this.question.status) {
            this.countErrors++;

            if (this.isExam) {
                this.error();
            }
        }

        if (this.isExam) {
            this.next();
        }
    }

    error() {

        if (this.themes && this.question && this.question.theme_id && this.examThemes.includes(this.question.theme_id)) {
            // console.log(`${this.question.theme_id}: ${this.question.title}`);
            this.themes.update(this.question.theme_id);

            // if (!this.themes.status) {
            //     this.finish();
            // }
        }
    }

    toQuestionMove(index: number) {
        if (this.showInfo) {
            this.currentIndex = index;
        }

        this.closeHint();
    }

    previous() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
        }

        this.closeHint();
    }

    nextButton() {
        if (this.currentIndex === this.questions.length - 1 && this.questions.firstUnAnswered !== null) {
            this.currentIndex = this.questions.firstUnAnswered;
        } else {
            this.next();
        }
    }

    next() {
        if (this.currentIndex + 1 < this.questions.length) {
            this.currentIndex++;
        }

        this.closeHint();
    }

    finish() {
        if (this.inProcess) {
            this.$store.commit("finishTest");
            this.$store.commit("finishExam");


            if (this.countAnswers > 0) {
                // console.log("writeResults");

                const title: string = this.data_title ? this.data_title : "Экзамен";
                const result: Result = new Result(this.questions, this.time, title, this.countErrors, this.countAnswers);
                this.$store.commit("addResult", result);

                this.$store.dispatch("writeResults");

                this.$emit('toResults', result);
            }

            // console.log("finish");
        }
    }

    showHint() {
        this.hint = !this.hint;
    }

    closeHint() {
        this.hint = false;
    }
}
